function AdminLogin() {
    window.location.replace(process.env.REACT_APP_COGNITO_ADMIN_SIGNIN);
  }
  
  function AdminSignup() {
    window.location.replace(process.env.REACT_APP_COGNITO_ADMIN_SIGNUP);
  }
  
  export { AdminLogin, AdminSignup };
  